import { render, staticRenderFns } from "./GradeNew.vue?vue&type=template&id=015c0e71"
import script from "./GradeNew.vue?vue&type=script&lang=js"
export * from "./GradeNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports